import { Grid, Typography, alpha, styled } from '@mui/material';
import { GridWrapperType } from './Type';

export const Heading = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(3),
  fontWeight: '600',
}));
export const SubHeading = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '500',
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(1),
}));
export const Name = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(2),
  fontWeight: '400',
  marginBottom: '6px',
}));
export const Details = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '400',
  marginBottom: '6px',
  color: theme.palette.text.secondary,
  display: 'flex',
  alignItems: 'center',
}));
export const Pincode = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '400',
  marginBottom: '6px',
  color: theme.palette.text.secondary,
}));
export const GridWrapper = styled(Grid)<GridWrapperType>(({ theme, hasBackground }) => ({
  padding: theme.spacing(3),
  borderRadius: 12,
  border: '1px solid var(--mui-palette-grey-300)',
  backgroundColor: hasBackground ? alpha(theme.palette.primary.main, 0.05) : 'unset',
}));
